<template>
  <article class="faq">
    <h3 class="question">
      <img :src="image" :alt="alt">
      <i v-html="question"></i>
    </h3>
    <div class="answer">
      <p>
        {{answer}}
      </p>
    </div>
  </article>
</template>

<script>
export default {
  name: 'staffFaqLink',
  props: {
    image: {
      type: String,
      default: "",
    },
    alt: {
      type: String,
      default: ""
    },
    question: {
      type: String,
      default: ''
    },
    answer: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.faq {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 100px;
  opacity: 0;
  transform: translateY(100px);
  transition: all 1s cubic-bezier(0.77, 0, 0.175, 1) 0.1s;
  @media print,screen and (max-width: 767px) {
    flex-direction: column;
    margin-top: 50px;    
  }
  &.is-show {
    opacity: 1;
    transform: translateY(0px);
  }
  .question {
    text-align: center;
    font-size: 28px;
    font-weight: bold;
    @media print,screen and (min-width: 768px) {
      width: 40%;
    }
    @media print,screen and (max-width: 767px) {
      font-size: 20px;
    }
    ::v-deep br {
      @media print,screen and (max-width: 767px) {
        display: none;
      }
    }
    img {
      margin: 0 auto;
      margin-bottom: 10px;
      display: block;
      height: 1.5em;
    }
  }
  &:nth-of-type(even) {
    @media print,screen and (min-width: 768px) {
      flex-direction: row-reverse;
    }
    .answer {
      @media print,screen and (min-width: 768px) {
        border-top: 2px solid #3fae00;
        border-left: none;
        border-right: 2px solid #3fae00;
      }
      &:before {
        @media print,screen and (min-width: 768px) {
          border-right: 0;
          border-left: 10px solid #3fae00;
          right: -12px;
          left: auto;
        }
      }
      &:after {
        @media print,screen and (min-width: 768px) {
          border-right: 0;
          border-left: 10px solid #fff;
          right: -9px;
          left: auto;
        }
      }
    }
  }
  .answer {
    max-width: 620px;
    width: 100%;
    border-top: 2px solid #3fae00;
    font-size: 15px;
    border-left: 2px solid #3fae00;
    padding: 20px;
    position: relative;
    box-sizing: border-box;
    &:before {
      content: "";
      width: 0;
      height: 0;
      border: 10px solid transparent;
      position: absolute;
      @media print,screen and (min-width: 768px) {
        border-right: 10px solid #3fae00;
        left: -22px;
        top: 50%;
        transform: translateY(-50%);
      }
      @media print,screen and (max-width: 767px) {
        left: 0;
        right: 0;
        margin: auto;
        border-bottom: 20px solid #3fae00;
        top: -30px;
      }
    }
    &:after {
      content: "";
      width: 0;
      height: 0;
      border: 10px solid transparent;
      position: absolute;
      @media print,screen and (min-width: 768px) {
        left: -19px;
        top: 50%;
        transform: translateY(-50%);
        border-right: 10px solid #fff;
      }
      @media print,screen and (max-width: 767px) {
        left: 0;
        right: 0;
        margin: auto;
        border-bottom: 20px solid #fff;
        top: -25px;
      }
    }
    p {
      margin: 0;
    }
  }
}
</style>